import React from 'react';
import WebsitePage from './WebsitePage';

const AboutPage = () => <WebsitePage slug="about" />;
export default AboutPage;
